import { Outlet, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Logo from "./Logo";
import Chatbot from "./Chatbot";
import CookieConsent from "./CookieConsent";
import { BorradorBanner } from "./BorradorBanner";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#1a1625] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="py-12 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <Logo />
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
              <Link to="/terms" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                Términos y Condiciones
              </Link>
              <Link to="/privacy" className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                Política de Privacidad
              </Link>
              <Link to="/cookies" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-testid="footer-cookies-link">
                Cookies
              </Link>
            </div>
            <p className="text-gray-500 text-sm">
              © 2026 Plazafy. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
      <Chatbot />
      <BorradorBanner />
      <CookieConsent />
    </div>
  );
}
